import React from 'react';

export default function({children, white, purple, lightYellow}){
    
    return <p className={`mb-5 text-md md:text-lg ${ white ? `text-white` : `` } ${ lightYellow ? `text-[#e1deb1]` : ``} ${ purple ? `text-dark-purple` : `` }`}>{children}</p>;

}